import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment as env} from '../../../../environments/environment';

/** Counts the API reports back after a demo reset. */
export interface DemoResetResult {
    journeysRestored: number;
    publishesRemoved: number;
    appliesRemoved: number;
    reoptsRemoved: number;
    overridesRemoved: number;
    overridesRestored: number;
    priorityOverridesRemoved: number;
}

/**
 * Demo-tenant controls. The API simulates re-opt, rule apply and send in-process on
 * demo tenants (rail.parameters demo_simulation); this is the reset that undoes them.
 */
@Injectable({
    providedIn: 'root'
})
export class DemoService {

    constructor(private http: HttpClient) {
    }

    /** True when the signed-in tenant runs the in-process demo simulation. */
    public isDemoSimulation(): boolean {
        try {
            const config = JSON.parse(localStorage.getItem('userConfig')) || {};
            return config.demoSimulation === true;
        } catch {
            return false;
        }
    }

    public resetDemo(): Observable<DemoResetResult> {
        return this.http.post<DemoResetResult>(`${env.apiBaseUrl}/demo/reset`, {});
    }
}
